<template>
    <div>
        <div ref="component" id="myChart1"></div>
    </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
    data() {
        this.isEchart = ""
        return {
            specialtyList: [],
        }
    },

    created() {},
    mounted() {
        // this.drawLine()
    },
    methods: {
        drawLine() {
            let dataList = [12, 13, 14, 15, 16, 17, 12, 15]
            this.isEchart = this.$echarts.init(
                document.getElementById("myChart1")
            )
            // this.$echarts.init(this.$refs.component, null, {
            // 	renderer: 'canvas'
            // })
            // 绘制图表
            this.isEchart.setOption({
                tooltip: {
                    trigger: "axis",
                },
                xAxis: {
                    type: "category",
                    data: [
                        "高血压",
                        "糖尿病",
                        "高血脂",
                        "家族遗传史",
                        "接种史",
                        "过敏史",
                        "疾病史",
                        "用药史",
                    ],
                    axisLine: {
                        lineStyle: {
                            color: "#fff",
                            borderWidth: 2,
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            // 设置Y轴颜色
                            color: "#fff",
                            borderWidth: 2,
                        },
                    },
                },
                series: [
                    {
                        data: dataList,
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#05b4f6",
                            },
                        },
                    },
                ],
            })
        },
    },
    beforeDestroy() {
        if (this.isEchart) {
            this.isEchart.clear()
        }
    },
}
</script>

<style lang="less" scoped>
#myChart1 {
    width: 100%;
    height: 260px;
}
</style>
